import TodoContext from "../todoCtx/TdoCtx";
import "./todoListItem.css"
import React, { useContext, useRef  } from 'react';
import moment from 'moment';
import CompTodoList from "../compTodoList/CompTodoList";
import { IoAddCircle, IoBackspace } from "react-icons/io5";
import AddItem from "../addItem/AddItem";
import ConfirmBox from "../confirmBox/ConfirmBox";

// moment().format();



const TodoListItem = () => {

  const dragItem = useRef();
  // const dragNode = useRef();
  // const dragOverItem = useRef();


  const {todos,setTodos,crtDrgSection,setCrtDrgSection,compTodos,setCompTodos,dragging, setDragging, isShown, setIsShown,markedTodos, setMarkedTodos, showCB, setShowCB  } = useContext(TodoContext);

  const handleClickAdd = event => {
    // 👇️ toggle shown state   
    setIsShown(current => !current);

    // 👇️ or simply set it to true
    // setIsShown(true);
  };

  const handleClickDlt = event => {
    // 👇️ toggle shown state   
    setShowCB(showCB => !showCB);

    // 👇️ or simply set it to true
    // setIsShown(true);
  };


  const deleteTodo = (event, id) => 

  {

      const newTodos = todos.filter(todo => { 
        return todo.id !== id}); 
      setTodos(newTodos);

  }


    const handleCheck = (event, id,item) => {


      setTodos(todos.map(todo => {
        if (todo.id === id) {
            todo.isMarked = !todo.isMarked;
            todo.bgColor = !todo.bgColor;
            todo.color = !todo.color; 
        }
        return todo;
    }))
    

    };

    // console.log("markedTodos",markedTodos);

    const handleDltMarked = (event, id) => {

      const newTodos = todos.filter(todo => { 
        return todo.isMarked === false}); 
      setTodos(newTodos);
      setShowCB(showCB => !showCB);



      
    };

    const dragStart = (e, position) => {

      console.log("you have started dragging")

    console.log("dragItem.current before",dragItem.current);
    console.log("position before",position);
      dragItem.current = position;
      console.log("e.target.id PENDINGGG",e.target.id);

    console.log("dragItem",dragItem);
    console.log("dragItem.current",dragItem.current);
    console.log("position",position);
    console.log("dragStart",e.target.innerHTML);
    };

    
    const dragEnter = (e) => {
      e.preventDefault();
      console.log("pendTodo:you have entered Pending Todos")
      const pendId = e.target.id;
    
      setCrtDrgSection(pendId);
      console.log("pendId",pendId);
    }

    const dragOver = (e) => {
      e.stopPropagation();
      e.preventDefault();
      }


// ******************* DROP ****************************

const drop = (e) => {

  const copyCompTodos = [...compTodos];
  const copyTodos = [...todos];
  const todoItem = copyCompTodos[dragItem.current]; //arr[0]
  // const todoOtherItem = copyTodos[dragItem.current]; 


  if ( e.target.id === "completed" ) {

  if (copyCompTodos.includes(todoItem) ) {

    e.preventDefault();

    

    copyCompTodos.splice(dragItem.current,1);
  
    console.log("copyCompTodos after splice",copyCompTodos);
  
  
    setCompTodos(copyCompTodos);
  
  
    // setCrtItem(todoItem);
  
  
    const newTodos = [ ...todos, todoItem ];
  
    setTodos(newTodos);
  
    
  }

  else{
    console.log("do nothing");
  }
   


  //step 1: remove item from copytodos
  //step 2: add item in completed todos
//  }
}

  
  else {
    console.log("id no match in completed")
  }
  } 



   

  return (

    <>

    {isShown && <AddItem/>}
    {showCB && <ConfirmBox handleDltMarked = {handleDltMarked} />}

    { !showCB && <div className="mainDiv" >

    {/* <div className='compTodosTitle'>
            <h1>Pending Tasks</h1>
        </div> */}
        
    <div className='todoListWrapper'>

      <div className="upperPart">

      <div className="todoListTitle">
      <h1>STUDENTS</h1>
      </div>

      <div>
      <IoAddCircle className="addIconId" onClick={handleClickAdd}  />
      </div>



      </div>

      

      <div className="listWithDlt">


      <div> {
      todos && todos.map((todo,index)=>(
        todo.isMarked && (<IoBackspace className="dltIconId" onClick={handleClickDlt} />)
      )) }  
      
      </div>


    <ul > <div className="todoListItems"
    id="pending"
    onDragEnter={dragging ? dragEnter : null}
    onDragOver={(e) => dragOver(e) }
    onDrop={(e) => drop(e) }> 
    {
     todos && todos.map((todo,index)=>(
      
      <li id={todo.id} key={index}  > 
          
        <div 
          
          draggable 
          className='todoListItem' 
          onDragStart={(e) => dragStart(e, index)}
          style={{
            backgroundColor: todo.isMarked ? '#AA1717' : '' ,
            color: todo.isMarked ? 'white' : ''
  
          }} 
          
                 
        > 

          <input className="tdlChkbox" type="checkbox" checked={todo.isMarked} onChange={event => handleCheck(event, todo.id, todo)} /> 
        
          <div className="fullName">
          
           {todo.fullName}
          
          </div>



     {/* <button onClick={event => deleteTodo(event, todo.id)} className='tdlDltBtn'>Delete</button>  */}

          </div>


       
               
      </li>
        
       
        
     ))
    }
    </div>
          
    </ul>

    </div>



    </div>

    <div className="listsDivider"></div>
    

    
    <div>

      <CompTodoList dragItem = {dragItem} />

    </div>
    
    
    </div> 
}
    
    </>)
}

export default TodoListItem